import { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from '../Sidebar/Sidebar';
import { Header } from '../Header/Header';
import { Toast } from '../Toast/Toast';
import { ImportModal } from '../ImportModal';
import { ExportModal } from '../ExportModal';
import { CopyYearModal } from '../CopyYearModal';
import { useUiStore } from '../../store/ui';
import { useUrlSync } from '../../store/urlSync';
import { useMe } from '../../store/queryHooks';
import { setAccent } from '../../lib/palette';
import styles from './AppShell.module.css';

export function AppShell() {
  useUrlSync();
  const me = useMe();
  useEffect(() => {
    if (me.data?.accent_color) setAccent(me.data.accent_color);
  }, [me.data?.accent_color]);
  const openMenu = useUiStore((s) => s.openMenu);
  const setOpenMenu = useUiStore((s) => s.setOpenMenu);
  const dark = useUiStore((s) => s.dark);
  const [showImport, setShowImport] = useState(false);
  const [showExport, setShowExport] = useState(false);
  const [showCopy, setShowCopy] = useState(false);

  // Keep html/body in sync with dark state so scroll-overshoot / rubber-band
  // areas outside the filtered subtree get the right color.
  useEffect(() => {
    const cls = 'budgetx-dark-bg';
    const root = document.documentElement;
    const body = document.body;
    root.classList.toggle(cls, dark);
    body.classList.toggle(cls, dark);
    return () => {
      root.classList.remove(cls);
      body.classList.remove(cls);
    };
  }, [dark]);

  return (
    <div className={`${styles.shell} ${dark ? 'budgetx-dark' : ''}`}>
      <Sidebar />
      <main className={styles.main}>
        <Header
          onOpenImport={() => setShowImport(true)}
          onOpenExport={() => setShowExport(true)}
          onOpenCopyYear={() => setShowCopy(true)}
        />
        <div data-print="area">
          <Outlet />
        </div>
      </main>

      {openMenu && <div className={styles.menuBackdrop} onClick={() => setOpenMenu(null)} />}
      {showImport && <ImportModal onClose={() => setShowImport(false)} />}
      {showExport && <ExportModal onClose={() => setShowExport(false)} />}
      {showCopy && <CopyYearModal onClose={() => setShowCopy(false)} />}
      <Toast />
    </div>
  );
}
